var $35da740d59af89ba$exports = {};
const $35da740d59af89ba$var$imgList = document.getElementById("imgList");
const $35da740d59af89ba$var$loadMore = document.getElementById("loadMore");
let $35da740d59af89ba$var$i = 1;
const $35da740d59af89ba$var$API_KEY = "51148638-4215382d54794cb096cce3e5a";
fetch(`https://pixabay.com/api/?key=${$35da740d59af89ba$var$API_KEY}&image_type=photo&per_page=10&page=${$35da740d59af89ba$var$i}`).then((res)=>{
    return res.json();
}).then((data)=>{
    console.log(data);
    $35da740d59af89ba$var$imgList.innerHTML = $35da740d59af89ba$var$createMarkUp(data.hits);
});
function $35da740d59af89ba$var$createMarkUp(data) {
    const newImages = data.map((image)=>`<li class="img__list__item">
            <img src=${image.largeImageURL} alt=${image.tags} class="images__photos" loading="lazy" onload="this.parentElement.classList.add('loaded')">
        </li>`).join('');
    return newImages;
}
$35da740d59af89ba$var$loadMore.addEventListener("click", ()=>{
    $35da740d59af89ba$var$i++;
    fetch(`https://pixabay.com/api/?key=${$35da740d59af89ba$var$API_KEY}&image_type=photo&per_page=10&page=${$35da740d59af89ba$var$i}`).then((res)=>{
        return res.json();
    }).then((data)=>{
        console.log(data);
        $35da740d59af89ba$var$imgList.innerHTML += $35da740d59af89ba$var$createMarkUp(data.hits);
    });
});


//# sourceMappingURL=hw17-pagination-js4.ace8e815.js.map
